<div class="autocomplete">
  <div class="input-icon">
    <input [(ngModel)]="searchTerm" type="text" class="form-control" placeholder="{{placeholder || 'Pretraži'}}" (keyup)="getOperations()">
    <div class="input-icon-addon">
      <i class="fe fe-search"></i>
    </div>
  </div>

  <div class="autocomplete__list" *ngIf="isListVisible">
    <div class="autocomplete__item" *ngFor="let operation of operations" (click)="onSelect(operation)">{{ operation.name }} ({{ operation.machineName }})</div>
  </div>
</div>